export default {
  title: {
    en: 'High Scores'
  },

  week: {
    en: 'Week'
  }
};
